import { Schema } from 'v4f'

export default Schema(
  {

  },
  { verbose: true, async: true }
)
